export const GALLERY_ROUTES = {
  GET_GALLERY: "/club/gallery",
};
